<template>
  <v-col cols="auto">
    <v-dialog v-model="dialog" transition="dialog-bottom-transition" max-width="1000" persistent>
      <template v-slot:activator="{ on, attrs }">
        <v-fab-transition> 
          <v-btn
            v-bind="attrs"
            v-on="on"
            color="primary"
            class="text-capitalize button-shadow mb-3 mb-sm-0"
          >Novo Projeto</v-btn>
        </v-fab-transition>
      </template>
      <template>
        <ProjetoEditor @cancel="fecharELimpar"></ProjetoEditor>
      </template>
    </v-dialog>
  </v-col>
</template>

<script>
import ProjetoEditor from "@/components/Projeto/ProjetoEditor"
import {mapActions} from "vuex";

export default {
  components: {
    ProjetoEditor
  },
  props: {
  },
  computed: {


  },
  data() {
    return {
      valid: true,
      dialog: false,
      formulario: {}
    };
  },
  created() {
    
  },
  methods: {
    ...mapActions('organizacao', ['criarOrganizacao']),

    save() {
      if(this.$refs.form.validate()) {
        this.create().then((organizacao) => {
          this.$refs.form.resetValidation()
          this.formulario = {};
          this.$emit("save", { organizacao });
          this.fecharELimpar()
        })
         .catch((error) => {
           if (error.response) {
             this.errorMessage = error.response.data
           }
         })
      }
    },
    create() {
      return this.criarOrganizacao(this.formulario);
    },
    fecharELimpar() {
      this.formulario = {}
      this.dialog = false
    },
  
  },  
};
</script>